exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-4a024d5e] .v-input {\n  flex: unset;\n  min-width: 350px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/stylus-loader!./node_modules/vue-loader/lib??vue-loader-options!./src/views/authen/logout.vue?vue&type=style&index=0&id=4a024d5e&lang=stylus&scoped=true&
// module id = 737
// module chunks = 5